import { useState } from 'react';
import { AuthErrorContext } from '.';

export function AuthErrorProvider({
  children,
  initialError,
}: {
  children: React.ReactNode;
  initialError?: string | null;
}) {
  const [error, setError] = useState<any>(initialError ?? null);

  return (
    <AuthErrorContext.Provider value={{ error, setError }}>
      {children}
    </AuthErrorContext.Provider>
  );
}
